// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import BasketItemResourceViewModel from '../../../../viewModel/resource/BasketItemResourceViewModel';
import AddressResourceViewModel from '../../../../viewModel/resource/AddressResourceViewModel';
import BasketSummaryResourceViewModel from '../../../../viewModel/resource/BasketSummaryResourceViewModel';
import BasketResourceViewModel from '../../../../viewModel/resource/BasketResourceViewModel';
import BasketResourceDTO from '../../dto/resource/BasketResourceDTO';

export default abstract class BasketResourceModel extends BaseModel<BasketResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get basketItems() { return this.getArrayModels(() => this.dto.basketItems, BasketItemResourceViewModel)!; }
  set basketItems(value) { this.setArrayModels(() => this.dto.basketItems, value); }
  /**
  */
  get addresses() { return this.getArrayModels(() => this.dto.addresses, AddressResourceViewModel)!; }
  set addresses(value) { this.setArrayModels(() => this.dto.addresses, value); }
  /**
  */
  get isShippingSameAsInvoice() { return this.dto.isShippingSameAsInvoice; }
  set isShippingSameAsInvoice(value) { this.dto.isShippingSameAsInvoice = value; }
  /**
  */
  get summary() { return this.getArrayModels(() => this.dto.summary, BasketSummaryResourceViewModel)!; }
  set summary(value) { this.setArrayModels(() => this.dto.summary, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    value = qs.isShippingSameAsInvoice === 'true' ? true : qs.isshippingsameasinvoice;
    value = qs.isShippingSameAsInvoice === 'false' ? false : undefined;
    this.dto.isShippingSameAsInvoice = value;
  }
}
